import * as React from "react";
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
} from "@mui/material";
import {
    getAllUnit,
    getAllUnits,
    getContractByUnit,
    getContractDoc,
    getContractPdc,
    getSearchReport,
} from "state/apis";
import { FcApproval } from "react-icons/fc";
import Header from "components/Header";
import { TextField, Grid } from "@mui/material";
import DefaultProperty from "components/DefaultProperty";
import { useSelector } from "react-redux";
import Autocomplete from "@mui/material/Autocomplete";
import { toast } from "react-toastify";
import moment from "moment";
import IconButton from "@mui/material/IconButton";
import { useLocation } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VoucherDetails from "scenes/voucherReceipts/VoucherDetails";
import { formatAmount } from "utils/constants";
import AddDocuments from "./AddDocument";
import StatBox from "components/StatBox";
import { useTheme } from "@mui/material/styles";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const Search = () => {
    const theme = useTheme();
    const propertyName = useSelector((state) => state.global.propertyName);
    const property = useSelector((state) => state.global.defaultProperty);
    const [isLoading, setIsLoading] = React.useState(false);
    const [data, setData] = React.useState({});
    const [documents, setDocuments] = React.useState({});
    const [pdc, setPdc] = React.useState({});
    const [openDefaultProperty, setOpenDefaultProperty] = React.useState(false);
    const [units, setFlat] = React.useState([]);
    const [contractData, setContractData] = React.useState([]);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const unitIdFromUrl = queryParams.get("unitId");
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [openPopup, setOpenPopup] = React.useState(false);
    const [showAddDocument, setShowAddDocument] = React.useState({
        show: false,
        contractId: null,
    });

    const [filter, setFilter] = React.useState({
        unitId: "",
        contractId: "",
    });

    const handleDocumentOpen = (url) => {
        window.open(url, "_blank");
    };

    React.useEffect(() => {
        setIsLoading(true);
        if (!property) {
            setOpenDefaultProperty(true);
        } else {
            fetchUnit();
            if (unitIdFromUrl) {
                setFilter((prevData) => ({
                    ...prevData,
                    unitId: unitIdFromUrl ? unitIdFromUrl : null,
                }));
            }
        }
        setIsLoading(false);
    }, []);

    React.useEffect(() => {
        if (filter.unitId) {
            fetchContractList();
        }
    }, [filter?.unitId]);

    React.useEffect(() => {
        if (filter.contractId) {
            setIsLoading(true);
            fetchContract();
            setIsLoading(false);
        } else {
            setData({});
            setDocuments([]);
            setPdc([]);
        }
    }, [filter.contractId]);

    const fetchContractList = async () => {
        try {
            const res = await getContractByUnit({
                unitId: filter?.unitId,
            });
            if (!res.contract.length) {
                setData({});
                setDocuments([]);
                setPdc([]);
                return toast.error("Contract details not found.");
            }
            setContractData(res.contract);
            setFilter((prevData) => ({
                ...prevData,
                contractId: res.contract[0]?.id,
            }));
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchUnit = async (id) => {
        const res = await getAllUnits(10000, 0, "", property);
        setFlat(res.data);
    };

    const fetchContract = async () => {
        try {
            if (filter.contractId) {
                const response = await getSearchReport(filter.contractId);
                const document = await getContractDoc(filter.contractId);
                const pdc = await getContractPdc(filter.contractId);
                setData(response?.data);
                setDocuments(document?.data);
                setPdc(pdc?.data);
            } else {
                setData({});
                setDocuments([]);
                setPdc([]);
                return toast.error("Contract details not found.");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const handleSubmitAddContract = async () => {
        setShowAddDocument({
            show: false,
            contractId: null,
        });
        setIsLoading(true);
        fetchContract();
    };

    const handleOpenPopup = (row) => {
        setSelectedRow(row);
        setOpenPopup(true);
    };

    const handleUnitChange = (newValue) => {
        setFilter((prevData) => ({
            ...prevData,
            unitId: newValue ? newValue.id : null,
        }));
        setData({});
        setContractData([]);
        setDocuments([]);
        setPdc([]);
    };

    const handleContactChange = (newValue) => {
        setFilter((prevData) => ({
            ...prevData,
            contractId: newValue ? newValue.id : null,
        }));
    };

    const handleCloseDefaultProperty = () => {
        setOpenDefaultProperty(false);
    };

    let totalCredit = 0;
    let totalDebit = 0;
    let totalVoucher = 0;
    let totalPdc = 0;
    return (
        <Box m="1.5rem 2.5rem" mb={5}>
            <Header title="SEARCH" subtitle="Search Unit" />
            <Box display="flex" justifyContent="flex-end" p={2} pb={0} mb={0} paddingLeft={0}>
                <Grid container spacing={1} p={"1px"} alignItems="center">
                    <Grid item xs={4}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={units}
                            getOptionLabel={(option) => option.unitNumber}
                            value={
                                filter.unitId
                                    ? units.find((unit) => unit.id == filter.unitId)
                                    : null
                            }
                            onChange={(event, newValue) => handleUnitChange(newValue)}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                    {option.unitNumber}
                                </li>
                            )}
                            sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                    "&.Mui-focused fieldset": {
                                        borderColor: "primary.main",
                                    },
                                },
                                "& .MuiInputLabel-root": {
                                    "&.Mui-focused": {
                                        color: "primary.main",
                                    },
                                },
                            }}
                            renderInput={(params) => (
                                <TextField {...params} fullWidth label="Select Unit" />
                            )}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={contractData}
                            getOptionLabel={(option) =>
                                `${moment(option.contractFrom).format("DD/MM/YYYY")} TO ${moment(
                                    option.contractTo
                                ).format("DD/MM/YYYY")}`
                            }
                            value={
                                filter?.contractId
                                    ? contractData.find(
                                          (contract) => contract.id === filter?.contractId
                                      )
                                    : null
                            }
                            onChange={(event, newValue) => handleContactChange(newValue)}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                    {`${moment(option.contractFrom).format(
                                        "DD/MM/YYYY"
                                    )} TO ${moment(option.contractTo).format("DD/MM/YYYY")}`}
                                </li>
                            )}
                            sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                    "&.Mui-focused fieldset": {
                                        borderColor: "primary.main",
                                    },
                                },
                                "& .MuiInputLabel-root": {
                                    "&.Mui-focused": {
                                        color: "primary.main",
                                    },
                                },
                            }}
                            renderInput={(params) => (
                                <TextField {...params} fullWidth label="Select Contract" />
                            )}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Grid item xs={6}>
                            {/* <span
                                style={{
                                    color:
                                        data?.closed === false
                                            ? "green"
                                            : data?.terminated === true && data?.terminatedDate
                                            ? "red"
                                            : "red",
                                }}
                            >
                                {data?.closed === false ? (
                                    "Active"
                                ) : data?.terminated === true && data?.terminatedDate ? (
                                    <>
                                        <strong style={{ fontWeight: "bolder" }}>Terminated</strong>
                                        : {moment(data.terminatedDate).format("DD/MM/YYYY")}
                                    </>
                                ) : Object.keys(data).length === 0 ? (
                                    ""
                                ) : (
                                    "Closed"
                                )}
                            </span> */}
                            <span
                                style={{
                                    color:
                                        data?.closed === false
                                            ? "green"
                                            : data?.terminated === true && data?.terminatedDate
                                            ? "red"
                                            : "red",
                                }}
                            >
                                {data?.closed === false ? (
                                    "Active"
                                ) : data?.terminated === true && data?.terminatedDate ? (
                                    <>
                                        <strong style={{ fontWeight: "bolder" }}>Terminated</strong>
                                        {`: ${moment(data.terminatedDate).format("DD/MM/YYYY")}`}
                                    </>
                                ) : Object.keys(data).length === 0 ? (
                                    ""
                                ) : (
                                    "Closed"
                                )}
                            </span>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
            {Object.keys(data).length > 0 && (
                <>
                    <Box display="flex" gap="16px" mt="16px" mb="16px">
                        <StatBox
                            title="Annual Rent"
                            value={formatAmount(Number(data?.yearRent || 0))}
                            increase={`${data?.unit?.unitNumber || ""}`}
                            description={data?.tenant?.name || ""}
                            bgColor="#f5f5f5"
                            icon={
                                <HomeWorkIcon
                                    sx={{ color: "#5c6bc0", fontSize: "26px" }}
                                />
                            }
                        />
                        <StatBox
                            title="Total Received"
                            value={formatAmount(Number(data?.totalReceivedRent || 0))}
                            increase={`${data?.receipts?.filter(r => r.type === "credit" && !r.isReverse).length || 0} receipts`}
                            description={`Paid upto: ${data?.paidUntilDate || "-"}`}
                            bgColor="#f5f5f5"
                            icon={
                                <ReceiptLongIcon
                                    sx={{ color: "#43a047", fontSize: "26px" }}
                                />
                            }
                        />
                        <StatBox
                            title="Balance Due"
                            value={
                                <span style={{ color: ((data?.effectiveRent || data?.yearRent) - data?.totalReceivedRent) > 0 ? "#c62828" : "#2e7d32" }}>
                                    {formatAmount(Number((data?.effectiveRent || data?.yearRent) - data?.totalReceivedRent || 0))}
                                </span>
                            }
                            increase={
                                <span style={{ color: data?.dayDiff < 0 ? "#c62828" : "#2e7d32" }}>
                                    {data?.terminated ? "Terminated" : data?.closed ? "Closed" : `${data?.dayDiff || 0} days`}
                                </span>
                            }
                            description={data?.terminated ? `Pro-rated rent: ${formatAmount(Number(data?.effectiveRent || 0))}` : "Rent days remaining"}
                            bgColor="#f5f5f5"
                            icon={
                                <WarningAmberIcon
                                    sx={{ color: ((data?.effectiveRent || data?.yearRent) - data?.totalReceivedRent) > 0 ? "#c62828" : "#43a047", fontSize: "26px" }}
                                />
                            }
                        />
                        <StatBox
                            title="Total Expenses"
                            value={formatAmount(Number(data?.totalExpense || 0))}
                            increase={`${data?.expenses?.length || 0} entries`}
                            description={`Deposit: ${formatAmount(Number(data?.deposit || 0))}`}
                            bgColor="#f5f5f5"
                            icon={
                                <AccountBalanceIcon
                                    sx={{ color: "#ef6c00", fontSize: "26px" }}
                                />
                            }
                        />
                    </Box>
                    <Box p={2} border={1} borderColor="grey.500" borderRadius={2} mt={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <Typography>
                                    <strong>Property Name: </strong>
                                    {propertyName}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography>
                                    <strong>Unit Name: </strong>
                                    {data.unit.unitNumber}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography>
                                    <strong>Tenant: </strong>
                                    {data.tenant?.name}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography>
                                    <strong>Contact1: </strong> {data?.tenant?.contact1}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography>
                                    <strong>Contact2: </strong> {data?.tenant?.contact2}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography>
                                    <strong>Email: </strong> {data?.tenant?.contact3}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography>
                                    <strong>Contract From: </strong>{" "}
                                    {moment(data.contractFrom).format("DD/MM/YYYY")}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography>
                                    <strong>Contract To: </strong>{" "}
                                    {moment(data.contractTo).format("DD/MM/YYYY")}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography>
                                    <strong>Total Years Of Stay:</strong>
                                    {data.totalYearsOfStay
                                        ? `${data.totalYearsOfStay} years`
                                        : data.totalYears}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography>
                                    <strong>Annual Rent: </strong>{" "}
                                    {formatAmount(Number(data.yearRent))}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography>
                                    <strong>Deposit:</strong> {formatAmount(Number(data.deposit))}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography>
                                    <strong>Total Receipt:</strong>{" "}
                                    {formatAmount(Number(data.totalReceivedRent))}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography>
                                    <strong>Total Balance: </strong>
                                    {formatAmount(Number((data?.effectiveRent || data?.yearRent) - data?.totalReceivedRent))}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography>
                                    <strong>Total Rent Days: </strong>
                                    <span style={{ color: data.dayDiff < 0 ? "red" : "green" }}>
                                        {data?.closed ? 0 : data.dayDiff}
                                    </span>
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography>
                                    <strong>Rent Upto Date: </strong>
                                    {data.paidUntilDate}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box mt={2} p={2} border={1} borderColor="grey.500" borderRadius={2}>
                        <Typography variant="h5" mb={2}>
                            <strong>Rent Collection</strong>
                        </Typography>
                        <TableContainer component={Paper} mt={2}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Date</TableCell>
                                        <TableCell>Transaction</TableCell>
                                        <TableCell>Cheque No.</TableCell>
                                        <TableCell>Reference number</TableCell>
                                        <TableCell>Credit</TableCell>
                                        <TableCell>Debit</TableCell>
                                        <TableCell>Attachment</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.receipts.length > 0 ? (
                                        data.receipts.map((val, index) => {
                                            // Increment totals outside of the JSX
                                            totalCredit +=
                                                val?.type === "credit" ? parseInt(val.amount) : 0;
                                            totalDebit +=
                                                val?.type === "debit" ? parseInt(val.amount) : 0;

                                            return (
                                                <React.Fragment key={index}>
                                                    <TableRow>
                                                        <TableCell>
                                                            {val.date
                                                                ? moment(val.date).format(
                                                                      "DD/MM/YYYY"
                                                                  )
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell>{val.transactionType}</TableCell>
                                                        <TableCell>
                                                            {val?.cheque?.chequeSerialNumber
                                                                ? val?.cheque?.chequeSerialNumber
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell>
                                                            {val?.bankRefNumber
                                                                ? val?.bankRefNumber
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell
                                                            align={"right"}
                                                            style={{ color: "green" }}
                                                        >
                                                            {val?.type === "credit"
                                                                ? formatAmount(Number(val.amount))
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell
                                                            align={"right"}
                                                            style={{ color: "red" }}
                                                        >
                                                            {val?.type === "debit"
                                                                ? formatAmount(Number(val.amount))
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell>
                                                            {val?.attachment ? (
                                                                <Button
                                                                    onClick={() =>
                                                                        handleDocumentOpen(val.attachment)
                                                                    }
                                                                    variant="contained"
                                                                    color="primary"
                                                                    size="small"
                                                                >
                                                                    View
                                                                </Button>
                                                            ) : (
                                                                "-"
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                    {index === data.receipts.length - 1 && (
                                                        <TableRow>
                                                            <TableCell colSpan={4} align="right">
                                                                <strong>Total</strong>
                                                            </TableCell>
                                                            <TableCell align={"right"}>
                                                                <strong>
                                                                    {formatAmount(
                                                                        Number(totalCredit)
                                                                    )}
                                                                </strong>
                                                            </TableCell>
                                                            <TableCell align={"right"}>
                                                                <strong>
                                                                    {formatAmount(
                                                                        Number(totalDebit)
                                                                    )}
                                                                </strong>
                                                            </TableCell>
                                                            <TableCell></TableCell>
                                                        </TableRow>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={7} align="center">
                                                No expense data available
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Box mt={2} p={2} border={1} borderColor="grey.500" borderRadius={2}>
                        <Typography variant="h5" mb={2}>
                            <strong>Expenses</strong>
                        </Typography>
                        <TableContainer component={Paper} mt={2}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Date</TableCell>
                                        <TableCell>Type</TableCell>
                                        <TableCell>Description</TableCell>
                                        <TableCell>Remark</TableCell>
                                        <TableCell>Amount</TableCell>
                                        <TableCell>Attachment</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.expenses.length > 0 ? (
                                        data.expenses.map((val, index) => (
                                            <>
                                                <TableRow key={index}>
                                                    <TableCell>
                                                        {val.date
                                                            ? moment(val.date).format("DD/MM/YYYY")
                                                            : "-"}
                                                    </TableCell>
                                                    <TableCell>{val.expense_type?.name}</TableCell>
                                                    <TableCell>
                                                        {val?.description ? val?.description : "-"}
                                                    </TableCell>
                                                    <TableCell>
                                                        {val?.remarks ? val?.remarks : "-"}
                                                    </TableCell>
                                                    <TableCell align={"right"}>
                                                        {formatAmount(Number(val.amount))}
                                                    </TableCell>
                                                    <TableCell>
                                                        {val?.attachment ? (
                                                            <Button
                                                                onClick={() =>
                                                                    handleDocumentOpen(val.attachment)
                                                                }
                                                                variant="contained"
                                                                color="primary"
                                                                size="small"
                                                            >
                                                                View
                                                            </Button>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                                {index === data.expenses.length - 1 && (
                                                    <TableRow>
                                                        <TableCell colSpan={5} align="right">
                                                            <strong>Total</strong>
                                                        </TableCell>
                                                        <TableCell align={"right"}>
                                                            <strong>
                                                                {formatAmount(
                                                                    Number(data.totalExpense)
                                                                )}
                                                            </strong>
                                                        </TableCell>
                                                        <TableCell></TableCell>
                                                    </TableRow>
                                                )}
                                            </>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={6} align="center">
                                                No expense data available
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Box mt={2} p={2} border={1} borderColor="grey.500" borderRadius={2}>
                        <Typography variant="h5" mb={2}>
                            <strong>Vouchers</strong>
                        </Typography>
                        <TableContainer component={Paper} mt={2}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Voucher Receipt Number</TableCell>
                                        <TableCell>Date</TableCell>
                                        <TableCell>Property Name</TableCell>
                                        <TableCell>Owner Name</TableCell>
                                        <TableCell>Tenant Name</TableCell>
                                        <TableCell>Total Amount</TableCell>
                                        <TableCell>View</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.voucher.length > 0 ? (
                                        data.voucher.map((row, index) => {
                                            totalVoucher += parseInt(row.totalAmount);

                                            return (
                                                <React.Fragment key={index}>
                                                    <TableRow
                                                        hover
                                                        role="checkbox"
                                                        tabIndex={-1}
                                                        key={row.id}
                                                    >
                                                        <TableCell>{row?.voucherNumber}</TableCell>
                                                        <TableCell>
                                                            {row?.date
                                                                ? moment(row?.date).format(
                                                                      "DD/MM/YYYY"
                                                                  )
                                                                : ""}
                                                        </TableCell>
                                                        <TableCell>
                                                            {row?.property?.propertyName}
                                                        </TableCell>
                                                        <TableCell>
                                                            {row?.property?.owner?.name}
                                                        </TableCell>
                                                        <TableCell>{row.tenant?.name}</TableCell>
                                                        <TableCell align={"right"}>
                                                            {formatAmount(Number(row.totalAmount))}
                                                        </TableCell>
                                                        <TableCell>
                                                            <IconButton
                                                                onClick={() => {
                                                                    handleOpenPopup(row);
                                                                }}
                                                            >
                                                                <VisibilityIcon />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                    {index === data.voucher.length - 1 && (
                                                        <TableRow>
                                                            <TableCell colSpan={5} align="right">
                                                                <strong>Total</strong>
                                                            </TableCell>
                                                            <TableCell align={"right"}>
                                                                <strong>
                                                                    {formatAmount(
                                                                        Number(totalVoucher)
                                                                    )}
                                                                </strong>
                                                            </TableCell>
                                                            <TableCell></TableCell>
                                                        </TableRow>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={7} align="center">
                                                No voucher data available
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Box mt={2} p={2} border={1} borderColor="grey.500" borderRadius={2}>
                        <Typography variant="h5" mb={2}>
                            <strong>PDC</strong>
                        </Typography>
                        <TableContainer component={Paper} mt={2}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Sr No</TableCell>
                                        <TableCell>Cheque Serials Number</TableCell>
                                        <TableCell>Cheque Date</TableCell>
                                        <TableCell>Bank</TableCell>
                                        <TableCell>Type</TableCell>
                                        <TableCell>Amount</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {pdc?.length > 0 ? (
                                        pdc?.map((row, index) => {
                                            totalPdc += parseInt(row?.amount);
                                            return (
                                                <React.Fragment key={index}>
                                                    <TableRow
                                                        hover
                                                        role="checkbox"
                                                        tabIndex={-1}
                                                        key={row.id}
                                                    >
                                                        <TableCell>{index + 1}</TableCell>
                                                        <TableCell>
                                                            {row.chequeSerialNumber}{" "}
                                                            {row?.amount ===
                                                            parseInt(row.paidAmount) ? (
                                                                <FcApproval size={14} />
                                                            ) : (
                                                                ""
                                                            )}
                                                        </TableCell>
                                                        <TableCell>
                                                            {row.chequeDate
                                                                ? moment(row.chequeDate).format(
                                                                      "DD/MM/YYYY"
                                                                  )
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell>{row.banks.name}</TableCell>
                                                        <TableCell>
                                                            {row?.type === "rent"
                                                                ? "Rent"
                                                                : "Deposit"}
                                                        </TableCell>
                                                        <TableCell align={"right"}>
                                                            {formatAmount(Number(row?.amount))}
                                                        </TableCell>
                                                    </TableRow>
                                                    {index === pdc?.length - 1 && (
                                                        <TableRow>
                                                            <TableCell colSpan={5} align="right">
                                                                <strong>Total</strong>
                                                            </TableCell>
                                                            <TableCell align={"right"}>
                                                                <strong>
                                                                    {formatAmount(Number(totalPdc))}
                                                                </strong>
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={7} align="center">
                                                PDC not available
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Box mt={2} p={2} border={1} borderColor="grey.500" borderRadius={2}>
                        <Typography
                            variant="h5"
                            mb={2}
                            display={"flex"}
                            justifyContent={"space-between"}
                        >
                            <strong>Documents</strong>
                            {data?.closed === true && (
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                        setShowAddDocument({
                                            show: true,
                                            contractId: filter?.contractId,
                                        });
                                    }}
                                >
                                    Add Document
                                </Button>
                            )}
                        </Typography>
                        <TableContainer component={Paper} mt={2}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Sr No</TableCell>
                                        <TableCell>Name</TableCell>
                                        <TableCell>View</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {documents.length > 0 ? (
                                        documents.map((row, index) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    <TableRow
                                                        hover
                                                        role="checkbox"
                                                        tabIndex={-1}
                                                        key={row.id}
                                                    >
                                                        <TableCell>{index + 1}</TableCell>
                                                        <TableCell>{row.name}</TableCell>
                                                        <TableCell>
                                                            <IconButton
                                                                onClick={() =>
                                                                    handleDocumentOpen(row.url)
                                                                }
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                <VisibilityIcon />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={7} align="center">
                                                Documents not available
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </>
            )}
            <VoucherDetails
                open={openPopup}
                onClose={() => setOpenPopup(false)}
                // onSubmit={handleSubmitAddFlats}
                editData={selectedRow}
                editMode={!!selectedRow}
                property={property}
            />
            {!property && (
                <DefaultProperty
                    open={openDefaultProperty}
                    onClose={() => handleCloseDefaultProperty}
                />
            )}

            {showAddDocument?.show && (
                <AddDocuments
                    open={showAddDocument?.show}
                    onClose={() => {
                        setShowAddDocument({
                            show: false,
                            contractId: null,
                        });
                    }}
                    onSubmit={handleSubmitAddContract}
                    details={data}
                />
            )}
        </Box>
    );
};

export default Search;
